var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1178_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0349 17.6873H2.0814C2.03209 17.6873 1.98465 17.6668 1.95023 17.6324C1.91488 17.597 1.89535 17.5505 1.89535 17.5012V16.1514C1.89535 15.3793 2.44698 14.6984 3.29721 14.1198C4.81535 13.0835 7.27209 12.4305 10.0349 12.4305C10.42 12.4305 10.7326 12.1179 10.7326 11.7328C10.7326 11.3486 10.42 11.0352 10.0349 11.0352C6.94465 11.0352 4.20884 11.8082 2.51023 12.9663C1.21442 13.85 0.5 14.9728 0.5 16.1514V17.5012C0.5 17.9198 0.666512 18.3226 0.963256 18.6193C1.26 18.9152 1.66186 19.0826 2.0814 19.0826H10.0349C10.42 19.0817 10.7326 18.7691 10.7326 18.384C10.7326 17.9998 10.42 17.6863 10.0349 17.6873Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.035 0C7.21079 0 4.9187 2.29209 4.9187 5.11628C4.9187 7.94047 7.21079 10.2326 10.035 10.2326C12.8592 10.2326 15.1513 7.94047 15.1513 5.11628C15.1513 2.29209 12.8592 0 10.035 0ZM10.035 1.39535C12.0889 1.39535 13.7559 3.06233 13.7559 5.11628C13.7559 7.17023 12.0889 8.83721 10.035 8.83721C7.98103 8.83721 6.31405 7.17023 6.31405 5.11628C6.31405 3.06233 7.98103 1.39535 10.035 1.39535Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6162 11.8047C13.7874 11.8047 12.3027 13.2893 12.3027 15.1182C12.3027 16.947 13.7874 18.4326 15.6162 18.4326C17.4451 18.4326 18.9306 16.947 18.9306 15.1182C18.9306 13.2893 17.4451 11.8047 15.6162 11.8047ZM15.6162 13.2C16.6748 13.2 17.5353 14.0596 17.5353 15.1182C17.5353 16.1768 16.6748 17.0372 15.6162 17.0372C14.5576 17.0372 13.6972 16.1768 13.6972 15.1182C13.6972 14.0596 14.5576 13.2 15.6162 13.2Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3138 12.5014V10.932C16.3138 10.5469 16.0012 10.2344 15.6161 10.2344C15.231 10.2344 14.9185 10.5469 14.9185 10.932V12.5023C14.9185 12.8865 15.231 13.2 15.6161 13.2C16.0012 13.199 16.3138 12.8865 16.3138 12.5014Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9595 13.7582L19.0693 12.6475C19.3418 12.3759 19.3418 11.9331 19.0693 11.6614C18.7976 11.3889 18.3548 11.3889 18.0832 11.6614L16.9725 12.7712C16.7009 13.0438 16.7009 13.4856 16.9725 13.7582C17.2451 14.0298 17.6869 14.0298 17.9595 13.7582Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2321 15.8133H19.8024C20.1875 15.8133 20.5001 15.5008 20.5001 15.1156C20.5001 14.7305 20.1875 14.418 19.8024 14.418H18.2321C17.848 14.418 17.5354 14.7305 17.5354 15.1156C17.5345 15.5008 17.848 15.8133 18.2321 15.8133Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9725 17.4602L18.0832 18.57C18.3548 18.8426 18.7976 18.8426 19.0693 18.57C19.3418 18.2984 19.3418 17.8556 19.0693 17.584L17.9595 16.4733C17.6869 16.2016 17.2451 16.2016 16.9725 16.4733C16.7009 16.7458 16.7009 17.1877 16.9725 17.4602Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9185 17.7328V19.3031C14.9185 19.6882 15.231 20.0007 15.6161 20.0007C16.0012 20.0007 16.3138 19.6882 16.3138 19.3031V17.7328C16.3138 17.3486 16.0012 17.0361 15.6161 17.0352C15.231 17.0352 14.9185 17.3486 14.9185 17.7328Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2732 16.4733L12.1634 17.584C11.8908 17.8556 11.8908 18.2984 12.1634 18.57C12.435 18.8426 12.8778 18.8426 13.1494 18.57L14.2601 17.4602C14.5318 17.1877 14.5318 16.7458 14.2601 16.4733C13.9876 16.2016 13.5457 16.2016 13.2732 16.4733Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9994 14.418H11.4301C11.045 14.418 10.7324 14.7305 10.7324 15.1156C10.7324 15.5008 11.045 15.8133 11.4301 15.8133H12.9994C13.3845 15.8133 13.698 15.5008 13.6971 15.1156C13.6971 14.7305 13.3845 14.418 12.9994 14.418Z",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2601 12.7712L13.1494 11.6614C12.8778 11.3889 12.435 11.3889 12.1634 11.6614C11.8908 11.9331 11.8908 12.3759 12.1634 12.6475L13.2732 13.7582C13.5457 14.0298 13.9876 14.0298 14.2601 13.7582C14.5318 13.4856 14.5318 13.0438 14.2601 12.7712Z",
    fill: "#5E35B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1178_4816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesPurple);
export default __webpack_public_path__ + "static/media/rolesPurple.1b67e90ff1a198a4190e54ed794d8f5e.svg";
export { ForwardRef as ReactComponent };